/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export function createExtendedError( errorMessage: string, appData: unknown = null ): ExtendedError {
	return new ExtendedError( errorMessage, appData );
}

export class ExtendedError extends Error {
	public appData: unknown;

	constructor( errorMessage: string, appData?: unknown ) {
		super( errorMessage );

		this.appData = appData;
	}
}
